import { ComedianRow } from "@/data/comedians";
import { getApiClient } from "@punchup/utils";

export type MyComediansOrderBy = "name" | "published_at" | "last_posted";

/**
 * Fetches the comedians the authenticated user follows, ordered as requested.
 * Mirrors the mobile `getMyComedians` API so both clients share the same
 * `/api/v2/user/comedians?order_by=…` endpoint.
 */
export async function getMyComedians({
  orderBy = "name",
}: { orderBy?: MyComediansOrderBy } = {}): Promise<ComedianRow[]> {
  const api = getApiClient();
  const response = await api.get<{ data: ComedianRow[] }>(
    `/api/v2/user/comedians?order_by=${orderBy}`
  );
  return response.data;
}
